import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const requestCompOffAdminAPI = async (compOffData: string) => {
	const url = `${API_URL}RequestCompOffAdmin`;
	const requestData = {
		RequestCompOffAdminToken: compOffData,
	};
	return makeApiCall(url, requestData, 'POST');
};

export const getAllEmployeesCompOffAdminAPI = async (organisationData: string) => {
	const url = `${API_URL}GetAllEmployeesForCompOffAdmin`;
	const requestData = {
		GetAllEmployeesForCompOffAdminToken: organisationData,
	};
	return makeApiCall(url, requestData, 'POST');
};

export const getHolidaysCompOffAdminAPI = async () => {
	const url = `${API_URL}GetHolidays`;
	const requestData = {};
	return makeApiCall(url, requestData, 'POST');
};

